import { API_URL } from '@webapp/common/conf';

import './widget.css';

import {
    createPopupId,
    createPopupTriggerId,
    createSurveyUrl,
    div,
    frame,
    isMobile,
    onLoad,
    popupPrefix,
    reopenKey as reopenKeyRaw,
    request,
    ShowWindow
} from './common';
import { createShowNeverButton, Popup, resizePopupContent } from './html-popup';

const url = `${API_URL}/core/v1/get/popup`;

window.ttgrafSetPopupParams = ({ id }: AnyObject): void =>
    request(url, { survey: id }, (xhr) => {
        const reopenKey = `${reopenKeyRaw}-${id}`;
        const response = JSON.parse(xhr.response);
        const params = JSON.parse(response.params);

        if (isMobile && !params.mobileDisplay) {
            return null;
        }

        const {
            buttonBorderColor,
            buttonBorderRadius,
            buttonColor,
            buttonHeight,
            buttonTextColor,
            cancelReopen,
            closeButtonText,
            dontShowButtonText,
            elementColor,
            executeButtonText,
            intervalButtonColor,
            intervalButtonTextColor,
            showWindow,
            windowTimer
        } = params;

        const iframe = frame(id as number);
        iframe.src = createSurveyUrl(response.rewrite, 'popup', true);
        const autoHeight = params.popup_opened_auto_height;
        let width = `${params.popup_opened_width}vw`;
        let height = `${params.popup_opened_height}vh`;
        let openedPosition = params.popup_opened_position;

        if (isMobile) {
            width = '95%';
            openedPosition = 'center';

            if (params.mobileDisplay === 1) {
                height = '95%';
            } else if (params.mobileDisplay === 2) {
                height = '50%';
            }
        }

        const mainPopup = new Popup({
            id: `${popupPrefix}${id}`,
            close: true,
            content: iframe,
            elementColor,
            width: `max(${width}, 320px)`,
            height: autoHeight ? '200px' : `max(${height}, 200px)`,
            position: openedPosition,
            borderRadius: `${params.popup_opened_radius}px`,
            hideContainer: autoHeight
        });

        let popupOpened = false;
        let openByTimer = false;

        mainPopup.onOpen(() => {
            popupOpened = true;
            resizePopupContent(iframe, mainPopup, window.innerHeight * 0.95, (h, ...args) => {
                if (h > 0) {
                    iframe.iFrameResizer.sendMessage(['setParentHeight', h]);
                }
            });
        });

        const startTimer = (): void => {
            setTimeout(() => {
                if (!mainPopup.isOpened() && !popupOpened) {
                    mainPopup.open();
                    openByTimer = true;
                }
            }, parseInt(windowTimer, 10) * 1000 || 10000);
        };

        if (showWindow === ShowWindow.TIME_INTERVAL) {
            const openMainPopup = (): void => {
                const cancelReopen = localStorage.getItem(reopenKey);

                if (!cancelReopen) {
                    onLoad(startTimer);
                }
            };

            let cancelReopenPopup = null;

            if (cancelReopen) {
                const showLaterButton = document.createElement('button');
                showLaterButton.classList.add(`${popupPrefix}reopen__button`);
                showLaterButton.innerText = closeButtonText;
                showLaterButton.style.background = intervalButtonColor;
                if (intervalButtonTextColor === 'dark') {
                    showLaterButton.style.color = '#000';
                }

                const popupShowNeverButton = createShowNeverButton(
                    dontShowButtonText,
                    intervalButtonColor,
                    intervalButtonTextColor
                );

                showLaterButton.addEventListener('click', () => {
                    localStorage.removeItem(reopenKey);
                    cancelReopenPopup.close();
                });

                popupShowNeverButton.addEventListener('click', () => {
                    localStorage.setItem(reopenKey, 'true');
                    cancelReopenPopup.close();
                });

                const actions = div();
                actions.classList.add(`${popupPrefix}actions`);
                actions.appendChild(showLaterButton);
                actions.appendChild(popupShowNeverButton);

                cancelReopenPopup = new Popup({
                    id: createPopupId(id as number),
                    close: false,
                    className: `${popupPrefix}reopen`,
                    content: actions,
                    elementColor,
                    position: openedPosition
                });
            }

            mainPopup.onClose(() => {
                if (cancelReopenPopup && openByTimer && !localStorage.getItem(reopenKey)) {
                    cancelReopenPopup.open();
                }
            });

            openMainPopup();
        }

        if (showWindow === ShowWindow.BUTTON_CLICK) {
            const trigger = document.getElementById(createPopupTriggerId(id as number));

            if (trigger) {
                trigger.innerText = executeButtonText;
                trigger.classList.add(`${popupPrefix}trigger`);
                trigger.classList.add('active');

                trigger.style.background = buttonColor;
                if (buttonTextColor === 'dark') {
                    trigger.style.color = '#000';
                }
                trigger.style.height = `${parseInt(buttonHeight, 10)}px`;
                trigger.style.borderRadius = `${parseInt(buttonBorderRadius, 10)}px`;
                if (buttonBorderColor) {
                    trigger.style.border = `1px solid ${buttonBorderColor}`;
                }

                trigger.addEventListener('click', () => {
                    mainPopup.open();
                    openByTimer = false;
                });
            }
        }

        window.addEventListener('message', ({ data }) => {
            if (data === 'scrollTop') {
                setTimeout(() => mainPopup.scrollTop(), 100);
            }

            if (data === 'finish' || data === 'disqual') {
                localStorage.setItem(reopenKey, 'true');
            }
            const PREFIX = `[WidgetHeight-${id}]:`;
            if (typeof data === 'string' && data.slice(0, PREFIX.length) === PREFIX && autoHeight) {
                const height = data.replace(PREFIX, '');
                mainPopup.setHeight(height);
                mainPopup.showContainer();
                iframe.iFrameResizer.sendMessage(['setParentHeight', parseInt(height, 10)]);
            }
        });
    });
